import { render, staticRenderFns } from "./addProductRelationshipDialog.vue?vue&type=template&id=3a066ae4&scoped=true"
import script from "./addProductRelationshipDialog.vue?vue&type=script&lang=js"
export * from "./addProductRelationshipDialog.vue?vue&type=script&lang=js"
import style0 from "./addProductRelationshipDialog.vue?vue&type=style&index=0&id=3a066ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a066ae4",
  null
  
)

export default component.exports